import {
  IMyTrainingRecord,
  ITrainingProgress,
  ITrainingRecord,
} from "types/Training";

import { api } from ".";

// CLE-3015 Clear Certified. Every mutation invalidates "Training" so the banner and the profile chip
// refresh, and waive / reset also invalidate "Users" so the Users list picks the change up.
const trainingQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    // The argument is the current account id. The URL does not use it, but `enabled` is that
    // account's flag (read from the `account` header), so it keys the cache per account.
    getMyTraining: builder.query<
      { data: IMyTrainingRecord },
      string | undefined
    >({
      query: () => "user/me/training",
      providesTags: ["Training"],
    }),
    saveMyTraining: builder.mutation<
      { data: ITrainingRecord },
      ITrainingProgress
    >({
      query: (progress) => ({
        url: "user/me/training",
        method: "PUT",
        body: progress,
      }),
      invalidatesTags: ["Training"],
    }),
    waiveTraining: builder.mutation<
      { data: ITrainingRecord; message: string },
      string
    >({
      query: (userId) => ({
        url: `user/${userId}/training/waive`,
        method: "POST",
      }),
      invalidatesTags: ["Training", "Users"],
    }),
    resetTraining: builder.mutation<
      { data: ITrainingRecord; message: string },
      string
    >({
      query: (userId) => ({
        url: `user/${userId}/training/reset`,
        method: "POST",
      }),
      invalidatesTags: ["Training", "Users"],
    }),
  }),
});

export const {
  useGetMyTrainingQuery,
  useSaveMyTrainingMutation,
  useWaiveTrainingMutation,
  useResetTrainingMutation,
} = trainingQueries;
